import { X, CirclePlus } from "lucide-react";

const NestedCard = ({ 
    index, 
    fields, 
    register, 
    errors, 
    watch,
    onRemove, 
    onAddNested,
    onRemoveNested,
    groupName,
    mode
}) => {
    // 渲染巢狀陣列欄位
    const renderNestedArrayField = (field, fieldPath, error) => {
        const nestedArray = watch(fieldPath) || [];
        
        return (
            <div key={field.name} className="space-y-4">
                <label className="block text-sm font-medium">
                    {field.label}
                </label>
                
                <div className="space-y-4 pl-6 border-l-2 border-gray-200">
                    {nestedArray.map((_, nestedIndex) => (
                        <div 
                            key={nestedIndex}
                            className="relative border rounded-lg p-4 bg-gray-50"
                        >
                            {nestedArray.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => onRemoveNested(index, field.name, nestedIndex)}
                                    className="absolute -top-3 right-3 border border-red-500 bg-red-500 text-white hover:bg-red-600 rounded-full p-1"
                                >
                                    <X size={18} />
                                </button>
                            )}
                            
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                {field.fields.map(nestedField => {
                                    const nestedPath = `${fieldPath}.${nestedIndex}.${nestedField.name}`;
                                    const nestedError = error?.[nestedIndex]?.[nestedField.name];
                                    
                                    return (
                                        <div key={nestedField.name} className="space-y-1">
                                            <label className="block text-sm font-medium">
                                                {nestedField.label}
                                            </label>
                                            <input
                                                {...register(nestedPath)}
                                                className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                    nestedError ? 'border-red-500' : 'border-gray-300'
                                                }`}
                                            />
                                            {nestedError && (
                                                <p className="text-red-500 text-sm">
                                                    {nestedError.message}
                                                </p>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                    
                    <button
                        type="button"
                        onClick={() => onAddNested(index, field.name)}
                        className="ml-2 p-2 w-fit flex items-center text-gray-500 hover:text-gray-700"
                    >
                        <CirclePlus size={20} strokeWidth={1} />
                        <span className="ml-1 text-sm">新增{field.label}</span>
                    </button>
                </div>
            </div>
        );
    };

    // 渲染物件欄位
    const renderObjectField = (field, fieldPath, error) => (
        <div key={field.name} className="space-y-4">
            <label className="block text-sm font-medium">
                {field.label}
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border rounded-lg p-4 bg-gray-50">
                {field.fields.map(subField => {
                    const subFieldPath = `${fieldPath}.${subField.name}`;
                    const subError = error?.[subField.name];

                    // // 特別處理 money_raised 中的數字欄位
                    // const isNumberField = field.name === 'money_raised' && 
                    // (subField.name === 'value_usd' || subField.name === 'value');

                    // 檢查是否為需要數字驗證的欄位
                    const isNumberField = (
                        (field.name === 'money_raised' && (subField.name === 'value_usd' || subField.name === 'value')) ||
                        (field.name === 'price' && (subField.name === 'value_usd' || subField.name === 'value')) ||
                        // (field.name === 'org_num' || field.name === 'org_num_investors') ||
                        (field.name === 'org_funding_total' && (subField.name === 'value_usd' || subField.name === 'value'))
                    );

                    // 檢查是否為日期欄位
                    const isDateField = (
                        field.name === 'announced_on' && subField.name === 'value'
                    );

                    return (
                        <div key={subField.name} className="space-y-1">
                            <label className="block text-sm font-medium">
                                {subField.label}
                            </label>
                            <input
                                {...register(subFieldPath, {
                                    // 只有當欄位有值時才驗證是否為數字
                                    ...(isNumberField && {
                                        pattern: {
                                            value: /^\d*$/,
                                            message: '請輸入有效的數字'
                                        }
                                    }),
                                    // ...(mode === "edit" && isDateField && {
                                    //     pattern: {
                                    //       value: /^\d{4}-\d{2}-\d{2}$/,
                                    //       message: '請使用 YYYY-MM-DD 格式'
                                    //     }
                                    // })
                                    ...(field.pattern && {
                                        pattern: field.pattern
                                    })            
                                })}
                                className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                    subError ? 'border-red-500' : 'border-gray-300'
                                }`}
                            />
                            {subError && (
                                <p className="text-red-500 text-sm">
                                    {subError.message}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );

    // 渲染布林欄位
    const renderBooleanField = (field, fieldPath, error) => (
        <div key={field.name} className="space-y-1">
            <label className="flex items-center space-x-2">
                <input
                    type="checkbox"
                    {...register(fieldPath)}
                    className={`h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500 ${
                        error ? 'border-red-500' : ''
                    }`}
                />
                <span className="text-sm font-medium">{field.label}</span>
            </label>
            {error && (
                <p className="text-red-500 text-sm">{error.message}</p>
            )}
        </div>
    );

    // 渲染基本文字欄位
    const renderTextField = (field, fieldPath, error) => {
        const isNumberField = (fieldName) => {
            return ['org_num', 'org_num_investors'].includes(fieldName);
        };

        return (
            <div key={field.name} className="space-y-1">
                <label className="block text-sm font-medium">
                    {field.label}
                </label>
                <input
                    {...register(fieldPath, {
                        ...(isNumberField(field.name) && {
                            pattern: {
                                value: /^\d*$/,
                                message: '請輸入有效的數字'
                            }
                        }),
                        ...(field.pattern && {
                            pattern: field.pattern
                        })
                    })}
                    type='text'
                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        error ? 'border-red-500' : 'border-gray-300'
                    }`}
                />
                {error && (
                    <p className="text-red-500 text-sm">{error.message}</p>
                )}
            </div>
        );
    };

    return (
        <div className="border rounded-lg px-6 py-4 bg-white shadow-sm relative">
            <button
                type="button"
                onClick={onRemove}
                className="absolute -top-3 right-3 border border-red-500 bg-red-500 text-white hover:bg-red-600 rounded-full p-1"
            >
                <X size={18} />
            </button>
            
            <div className="space-y-6">
                {fields.map(field => {
                    const fieldPath = `${groupName}.${index}.${field.name}`;
                    const error = errors?.[groupName]?.[index]?.[field.name];

                    if (field.type === 'nested-array') {
                        return renderNestedArrayField(field, fieldPath, error);
                    }
                    if (field.type === 'object') {
                        return renderObjectField(field, fieldPath, error);
                    }
                    if (field.type === 'boolean') {
                        return renderBooleanField(field, fieldPath, error);
                    }
                    return renderTextField(field, fieldPath, error);
                })}
            </div>
        </div>
    );
};

export default NestedCard;